import apiService from '@/member/services/apiService'
//
const manageImportTabId = () => {
  return window.localStorage.getItem('manage_import_tab_id') || 1
}

const getDefaultState = () => {
  return {
    forestManagementComplexes: [],
    lastModifiedDateOfShapeFile: '',
    lastModifiedDateOfCsv: '',
    manageImportTabId: manageImportTabId() || 1,
  }
}

const state = getDefaultState()

const mutations = {
  SET_FOREST_MANAGEMENT_COMPLEXES(state, payload) {
    state.forestManagementComplexes = payload
  },
  SET_LAST_MODIFIED_DATE_OF_CSV(state, payload) {
    state.lastModifiedDateOfCsv = payload
  },
  SET_LAST_MODIFIED_DATE_OF_SHAPE_FILE(state, payload) {
    state.lastModifiedDateOfShapeFile = payload
  },
  //
  SET_MANAGE_IMPORT_TAB_ID(state, payload) {
    state.manageImportTabId = payload
    window.localStorage.setItem('manage_import_tab_id', payload)
  },
}

const actions = {
  async importShapeFile({ commit }, payload) {
    return await apiService.post(route('member.fcs.manage_import.import_shape_file'), payload)
  },
  async getSpatialFiles({ commit }, payload) {
    const res = await apiService.get(route('member.fcs.manage_import.spatial_files'), payload)
    if (res.success && res.data) {
      return res.data
    }
  },
  async getLastModifiedDateOfShapeFile({ commit }, payload) {
    const apiResult = await apiService.get(
      route('member.fcs.manage_import.get_last_modified_date_of_shape_file'),
      payload
    )
    if (apiResult.success && apiResult.data) {
      commit('SET_LAST_MODIFIED_DATE_OF_SHAPE_FILE', apiResult.data)
    }
  },
  async getLastModifiedDateOfCsv({ commit }, payload) {
    const apiResult = await apiService.get(route('member.fcs.manage_import.get_last_modified_date_of_csv'), payload)
    if (apiResult.success && apiResult.data) {
      commit('SET_LAST_MODIFIED_DATE_OF_CSV', apiResult.data)
    }
  },
  async getForestManagementComplexes({ commit }, payload) {
    const apiResult = await apiService.get(route('member.fcs.manage_import.list'), payload)
    if (apiResult && apiResult.data) {
      commit('SET_FOREST_MANAGEMENT_COMPLEXES', apiResult.data)
    }
  },
  async updateForestManagementComplexes({ commit }, payload) {
    return await apiService.post(route('member.fcs.manage_import.update_forest_management_complexes'), payload)
  },
  //set_tab_id
  setManageImportTabId({ commit }, payload) {
    commit('SET_MANAGE_IMPORT_TAB_ID', payload)
  },
  async getSpatialFileSettings({ commit }, payload) {
    const apiResult = await apiService.get(route('member.fcs.spatial-file.get-spatial-file-settings'), payload)
    if (apiResult && apiResult.data) {
      return apiResult.data
    }
  },
  async setSpatialFileSettings({ commit }, payload) {
    const apiResult = await apiService.post(route('member.fcs.spatial-file.set-spatial-file-settings'), payload)
    if (apiResult && apiResult.data) {
      return apiResult.data
    }
  },
}

export default {
  state,
  mutations,
  actions,
}
